import React from 'react'

import { FormikDropdown } from 'components/FormikFields'
import { FormikDropdownChild } from 'components/FormikFields/FormikDropdown/FormikDropdown'
import AssetCondition from 'state/enums/AssetCondition'

interface Props {
    disabled?: boolean
    fieldName: string
    label?: string
    prefilled?: boolean
}

const AVAILABLE_VEHICLE_CONDITIONS_OPTIONS: Record<string, AssetCondition> = {
    New: AssetCondition.NEW,
    Used: AssetCondition.USED,
}

export default function ConditionDropdown({
    fieldName,
    label,
    disabled = false,
    prefilled = false,
}: Readonly<Props>) {
    return (
        <FormikDropdown
            name={fieldName}
            label={label ?? 'Condition'}
            placeholder="Select"
            disabled={disabled}
            prefilled={prefilled}
        >
            {Object.keys(AVAILABLE_VEHICLE_CONDITIONS_OPTIONS).map(
                (condition) =>
                    ({
                        name: condition,
                        value: AVAILABLE_VEHICLE_CONDITIONS_OPTIONS[condition],
                    }) as FormikDropdownChild,
            )}
        </FormikDropdown>
    )
}
